import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import Header from './libs/header';
// import AOS from 'aos';
// import "aos/dist/aos.js";

import Swiper from 'swiper';
// import './libs/sticky-sidebar';


import './libs/slider';
import './libs/other';
import './libs/gotosearch';
import './libs/jquery.magnific-popup.min';
import './libs/search';
// import './libs/kalkulator';
// import Header from './libs/header';
// import './libs/wcag';
// import './libs/story';
// import './libs/structure';
// import './libs/patronat';
// import './libs/igrzyska';

$(document).ready(() => {
  console.log("TEST9");
});
if ($('#open-popup').length) {
  $('#open-popup').magnificPopup({
    items: {
      src: '#popup-form', // ID elementu, który ma być wyświetlony w popupie
      type: 'inline'
    },
    closeBtnInside: true, // Przycisk zamknięcia wewnątrz popupu
    midClick: true
  });
}

$(document).on('wpcf7mailsent', function(event) {
  setTimeout(function() {
    $.magnificPopup.close(); // Zamknięcie popupu po 5 sekundach
  }, 3500); // 5000 milisekund = 5 sekund
});

// AOS.init(); 
// Your scripts here
$('#header .header').each((i, e) => {
  new Header(e, $(e));
});

const $headerE = $('#header');
const $headerP = $('.header');
const $headerT = $('.topheader');
const $btt = $('.backtotop');
$(window).on('scroll', () => {
  let scroll = window.scrollY;
  if (scroll > 20) {
    scroll = $headerP.height();
    $headerE.addClass('header__sticky_head');
    $btt.addClass('header__sticky_head');
    $headerT.addClass('topheader__sticky_tophead');
  } else {
    $headerE.removeClass('header__sticky_head');
    $btt.removeClass('header__sticky_head');
    $headerT.removeClass('topheader__sticky_tophead');
  }
  // $headerE.css('margin-top', scroll * -1 + 'px');
});
$(window).trigger('scroll');

$('.backtotop').on('click', function(){
   $("html, body").animate({scrollTop: 0}, 1000);
});


let header__menuwrap = $('.header__menuwrap').css('width');
let sm_width = (parseInt(header__menuwrap) - 250);


$('.header .menu-parent-2 > li.sports_menu .menuusl').css('width',sm_width);
$('.header .menu-parent-2 > li.paraoli_menu .menuusl').css('width',sm_width);